// extracted by mini-css-extract-plugin
module.exports = {"features-container":"features-container--T1fk51","featuresContainer":"features-container--T1fk51","icon":"icon--1Es7sW"};